import React from 'react';
import { PUBLIC_URL } from '../utils/const';
import Layout from '../layouts/Layout';
import { Container, Title, Text, List, Paper, Stack, Anchor, Box } from '@mantine/core';

const Privacy: React.FC = () => {
    return (
        <Layout>
            <Box className="content">
                <Container size="md">
                    <Stack align="center" my="xl">
                        <Title order={1} style={{ fontSize: '2rem' }}>Google API Services Usage Disclosure</Title>
                        <Title order={4}>Calensync</Title>
                        <Title order={6}>Service provided by Opali S.A.R.L.-S</Title>
                    </Stack>

                    <Title order={2}>Limited Use</Title>

                    <Text size="lg" mt="md" mb="md">
                        Our service strictly complies with all conditions specified in the{' '}
                        <Anchor href="https://developers.google.com/terms/api-services-user-data-policy">
                            Google API Services User Data Policy
                        </Anchor>
                        {' '}including the{' '}
                        <Anchor href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">
                            limited use policy of Google.
                        </Anchor>
                    </Text>

                    <Text>These include:</Text>

                    <List mt="xs">
                        <List.Item>
                            Do not allow humans to read the user's data unless you have obtained the user's
                            affirmative agreement to view specific messages, files, or other data.
                        </List.Item>
                        <List.Item>
                            Do not use or transfer the data for serving ads, including retargeting,
                            personalized, or interest-based advertising.
                        </List.Item>
                        <List.Item>
                            Limit your use of data to providing or improving user-facing features that are prominent in the requesting application's user interface. All other uses of the data are prohibited.
                        </List.Item>
                        <List.Item>
                            Only transfer the data to others if necessary to provide or improve user-facing
                            features that are prominent in the requesting application's user interface.
                        </List.Item>
                    </List>

                    <Text mt="md">
                        Our <Anchor href={`${PUBLIC_URL}/privacy`}>privacy policy</Anchor> page documents in detail what data our app is requesting
                        and why the requests access to Google user data.
                    </Text>
                </Container>
            </Box>
        </Layout>
    );
};

export default Privacy;

